var React = require('react');

function FrontendNavigationContacts (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M14.5 8h0.5c0.552 0 1-0.448 1-1v-2h-1.5v3z","key":0}),React.createElement("path",{"fill":"#000000","d":"M14.5 1v3h0.5c0.552 0 1-0.448 1-1v-2h-1.5z","key":1}),React.createElement("path",{"fill":"#000000","d":"M14 9v-9h-13c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h13v-7zM8 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995zM3 15h-1v-14h1v14zM11 12h-6v-1c0-1.105 0.895-2 2-2h2c1.105 0 2 0.895 2 2v1z","key":2}),React.createElement("path",{"fill":"#000000","d":"M14.5 12h0.5c0.552 0 1-0.448 1-1v-2h-1.5v3z","key":3})]);
}

FrontendNavigationContacts.displayName = "FrontendNavigationContacts";

FrontendNavigationContacts.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendNavigationContacts;

FrontendNavigationContacts.default = FrontendNavigationContacts;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-navigation-contacts.svg
// module id = 1001
// module chunks = 0